import Vue from 'vue'

export const SET_FILES = 'SET_FILES';
export const SET_IMAGES = 'SET_IMAGES';
export const SET_VIDEOS = 'SET_VIDEOS';
export const UPLOAD_FAIL = 'UPLOAD_FAIL';
export const SET_RAWFILES = 'SET_RAWFILES';
export const SET_ABORTINDEX = 'SET_ABORTINDEX';
export const SET_DELETEINDEX = 'SET_DELETEINDEX';

export default {
  state: {
    fileUrls: [],
    imageUrls: [],
    videoUrls: [],
    uploadFail: false,
    rawFiles: [],
    abortIndex: [],
    deleteIndex: [],


  },
  mutations: {
    [SET_FILES](state, files) {
      Vue.set(state, 'fileUrls', files.fileUrls)
    },
    [SET_IMAGES](state, files) {
      Vue.set(state, 'imageUrls', files.fileUrls)
    },
    [SET_VIDEOS](state, files) {
      Vue.set(state, 'videoUrls', files.fileUrls)
    },
    [UPLOAD_FAIL](state, type) {
      Vue.set(state, 'uploadFail', type)
    },
    [SET_RAWFILES](state, files) {
      Vue.set(state, 'rawFiles', files)
    },
    [SET_ABORTINDEX](state, index) {
      Vue.set(state, 'abortIndex', index)
    },
    [SET_DELETEINDEX](state, index) {
      Vue.set(state, 'deleteIndex', index)
    },

  },
  actions: {
    [SET_FILES]({commit}, files) {
      commit(SET_FILES, files)
    },
    [SET_IMAGES]({commit}, files) {
      commit(SET_IMAGES, files)
    },
    [SET_VIDEOS]({commit}, files) {
      commit(SET_VIDEOS, files)
    },
    [UPLOAD_FAIL]({commit}, type) {
      commit(UPLOAD_FAIL, type)
    },
    [SET_RAWFILES]({commit}, files) {
      commit(SET_RAWFILES, files)
    },
    [SET_ABORTINDEX]({commit}, index) {
      commit(SET_ABORTINDEX, index)
    },
    [SET_DELETEINDEX]({commit}, index) {
      commit(SET_DELETEINDEX, index)
    },

  }
}



// WEBPACK FOOTER //
// ./src/store/uploadFile.js